<template>
  <!-- 数字人列表组件 -->
  <div class="digital-human-container">
    <div class="digital-human-title">
      <div class="digital-human-title-text">数字人列表</div>
            <el-button type="primary" @click="goBack()"
              >上一步</el-button
            >
    </div>
    <div class="digital-human-subtitle">
      注：如需制作2D数字人自定义人物，请联系工作人员。并准备资料。（具体资料内容请查看<span
        @click="handleClickLink"
        class="subtitleLink"
        >《虚拟数字人2D形象定制指南》</span
      >）
    </div>
    <div class="digital-human-content-list">
      <div
        class="digital-human-content-list-item"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="imgBox">
          <el-image
            class="digital-human-content-list-item-img"
            :src="item.image"
            fit="contain"
          ></el-image>
          <div class="mask"></div>
          <div class="btn">
            <el-button type="primary" @click="handleSelect(item)"
              >制作视频</el-button
            >
          </div>
        </div>
        <div class="digital-human-content-list-item-text">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { digitalHumanPage } from "@/assets/api/aiProduct";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    async getData() {
      try {
        const res = await digitalHumanPage({
          createdTime: "",
          modelType: "2d",
          pageNo: 1,
          pageSize: 200,
        });
        if (res.data) {
          this.list = res.data.records;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    goBack(){
      this.$emit('back')
    },    /**
     * 选中数字人
     * @param item
     */
    handleSelect(item) {
      this.$emit("select", item);
    },

    /**
     * 查看2D虚拟形象定制指南
     */
    handleClickLink() {
      window.open(
        "https://aliavatar.yuque.com/org-wiki-aliavatar-fa7ng3/yxc45d/golwgxe41rs67uov?singleDoc#"
      );
    },
  },
};
</script>

<style scoped>
.digital-human-container {
  width: 1140px;
}

.digital-human-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
}

.digital-human-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.digital-human-subtitle {
  font-size: 12px;
  margin-bottom: 26px;
}

.digital-human-subtitle .subtitleLink {
  color: #1568eb;
  cursor: pointer;
}

.digital-human-content-list {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  height: 780px;
  overflow-y: scroll;
}

.digital-human-content-list-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.digital-human-content-list-item .imgBox {
  width: 260px;
  height: 260px;
  position: relative;
  border: 1px solid #acb2c3;
}

.digital-human-content-list-item .imgBox .digital-human-content-list-item-img {
  width: 100%;
  height: 100%;
}

.digital-human-content-list-item .imgBox:hover .mask,
.digital-human-content-list-item .imgBox:hover .btn {
  display: flex;
}

.digital-human-content-list-item:hover .digital-human-content-list-item-text {
  color: #1568eb;
}

.digital-human-content-list-item .imgBox .mask {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.digital-human-content-list-item .imgBox .btn {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.digital-human-content-list-item .digital-human-content-list-item-text {
  font-size: 14px;
}
</style>
